<template>
  <list class="m-0 p-0"
        v-model="questionnaires"
        :columns="columns"
        :pagination="pagination"
        :loading="pagination.loading"
        :actionColumnLabel="$t('Select')"
  >
    <template slot="header">
      <div class="col-lg-12 p-0">
        <h4 class="d-inline m-0 p-1">{{ $t('Result selection') }}</h4>
      </div>
      <fg-input class="pt-2 pb-2 btn-one-size-dropdown">
        <el-select size="large"
                   class="select-primary"
                   :placeholder="$t('Time frame')"
                   fullWidth
                   @input="setMonthsFilter"
                   :value="months">
          <el-option v-for="option in monthsOptions"
                     :value="option.value"
                     :label="$t(option.label)"
                     :key="option.value">
          </el-option>
        </el-select>
      </fg-input>
    </template>
    <template slot="actionsByRow" slot-scope="props">
      <router-link tag="a" :to="{ name: 'TeamSelection', params: { qid: props.row._id } }">
        <p-button round type="primary" size="sm" icon>
          <i class="fa fa-arrow-right"/>
        </p-button>
      </router-link>
    </template>
  </list>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import List from '../../Dashboard/Components/BasicList'
  import { Select, Option } from 'element-ui'

  export default {
    name: 'TeamQuestionnaires',
    components: {
      List,
      [Select.name]: Select,
      [Option.name]: Option
    },
    data () {
      return {
        sf: 'createdAt',
        so: 'desc',
        columns: [
          {
            name: 'title',
            text: 'Queries',
            sortable: false,
            align: 'left',
            formatter: this.languageFormatter,
            minWidth: 150
          },
          {
            name: 'lastExecution',
            text: 'Most recent data',
            sortable: false,
            align: 'left',
            formatter: this.dateFormatter,
            minWidth: 150
          }
        ]
      }
    },
    mounted () {
      this.init()
    },

    computed: {
      ...mapState('user/teams', {
        months: state => state.months,
        monthsOptions: state => state.monthsOptions,
      }),
      ...mapState('user/teams/questionnaires', {
        questionnaires: state => state.items,
        pagination: ({ items, ...rest }) => rest
      })
    },

    methods: {
      ...mapActions('user/teams/questionnaires', ['getList']),
      ...mapActions('user/teams', ['setMonthsFilter', 'initPackageMonthsOptions']),
      async init () {
        this.initPackageMonthsOptions(this.$auth.user.customer.settings.contract.packageType)
        const newPage = parseInt(this.$route.query.page || '1', 10)
        await this.fetchQuestionnaires()
      },
      async fetchQuestionnaires () {
        const newPage = parseInt(this.$route.query.page || '1', 10)
        await this.getList({ perPage: this.pagination.perPage, page: newPage, sf: 'title', so: 'asc', search: { months: this.months, lang: localStorage.getItem('locale') } })
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      }
    },

    watch: {
      months (val) {
        if (val) {
          this.fetchQuestionnaires()
        }
      },
      '$route.query.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
  }
</style>